import React from "react";
import { ConnectorIdentity } from "../ConnectorIdentity";
import { ConnectorStatusBadge } from "../../atoms/ConnectorStatusBadge";
import { HeaderRow } from "./ConnectorCardHeader.styles";
import type { ConnectorCardHeaderProps } from "./ConnectorCardHeader.types";

/**
 * The badge is suppressed for `not_connected` — Figma shows no pill on cards
 * in the "Available connectors" section (status === not_connected is the
 * uninteresting default state).
 */
const shouldShowBadge = (status: ConnectorCardHeaderProps["status"]): boolean =>
  status !== "not_connected";

export const ConnectorCardHeader: React.FC<ConnectorCardHeaderProps> = ({
  displayName,
  iconUrl,
  providerLabel,
  status,
  statusLabel,
  className,
}) => (
  <HeaderRow className={className}>
    <ConnectorIdentity
      displayName={displayName}
      iconUrl={iconUrl}
      providerLabel={providerLabel}
    />
    {shouldShowBadge(status) ? (
      <ConnectorStatusBadge status={status} label={statusLabel} />
    ) : null}
  </HeaderRow>
);

export default ConnectorCardHeader;
